import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { IconComponent } from '../../../shared/icon/icon';

@Component({
  selector: 'app-debtors-queue',
  imports: [RouterLink, IconComponent],
  templateUrl: './debtors-queue.html',
  styleUrl: './debtors-queue.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DebtorsQueueComponent {}
